module.exports = __webpack_public_path__ + "media/images/voor_de_regio-d27c30cfb2173a0f5b993a5d8283a440.jpg";